var React = require('react');

function CheckboxTrueInline (overrides) {
const props = Object.assign({}, {"viewBox":"0 0 24 24","fill":"none"}, overrides);
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"4","fill":"currentColor","key":0}),React.createElement("path",{"d":"M18.001 8.242l-7.718 7.718-4.482-4.482","stroke":"#fff","strokeWidth":"2.49","strokeMiterlimit":"10","key":1})]);
}

module.exports = CheckboxTrueInline;

CheckboxTrueInline.default = CheckboxTrueInline;
